import React from 'react';

/**
 * @param {{ title: string, description?: string, icon?: string, children?: React.ReactNode }} props
 */
export function EmptyState({ title, description, icon = '◇', children }) {
  return (
    <div className="empty-state empty-state--boxed" role="status">
      <span className="empty-state__icon" aria-hidden>
        {icon}
      </span>
      <h3 className="empty-state__title">{title}</h3>
      {description ? <p className="empty-state__desc">{description}</p> : null}
      {children}
    </div>
  );
}
